import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import chatbox from './livechat-chatbox'
import LivechatChattool from './livechat-chattool'
import users from './livechat-users'

import { PAGE } from '@/constants/page.js'
import LivechatPagelist from './livechat-pagelist'
import LivechatSearch from './LivechatSearch'
import LivechatSearchBox from './LivechatSearchBox'
import LivechatTab from './LivechatTab'

export default {
  components: {
    chatbox: chatbox,
    users: users,
    Multiselect,
    LivechatChattool,
    LivechatPagelist,
    LivechatSearch,
    LivechatSearchBox,
    LivechatTab
  },
  data() {
    return {
      app: '',
      timer: '',
      type: 'bot',
      allrentcustomer: [],
      allrentsupplier: [],
      usersearching: false,
      toolListHeight: 0,
      showSearch: false,
      openStartDate: false,
      openStartTime: false,
      openEndDate: false,
      openEndTime: false,
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        session: '',
        assignadminname: ''
      },
      loading: false,
      selectedUser2: null
    }
  },
  async created() {
    var vm = this

    if (vm.$store.state.livechat.filter.search) {
      vm.$store.state.livechat.filter.search = ''
    }

    if (vm.$route.query.user) {
      this.$store.commit('SET_LIVECHAT_TYPE', vm.$route.query.user == 'bot' ? 'bot' : 'admin')
    }
    if (vm.$route.query.userid) {
      var userid = vm.$route.query.userid

      if (userid) {
        await vm.getUsersdata(userid).then(function (user) {
          if (user) {
            vm.selectedUser = {
              app: user.app,
              first_name: user.first_name,
              last_name: user.last_name,
              lastreply_time: null,
              profile_pic: user.profile_pic,
              session: '',
              sessionvalue: user.sessionvalue,
              userid: user.id,
              uu_areaname: null,
              type: user.context == 'contactadmin' ? 'admin' : ''
            }

            vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)
          } else {
            vm.$swal({
              type: 'info',
              title: 'Not found this user'
            })
          }
        })
      }
    }

    if (
      this.selectedBot.theme == 'ticket' ||
      this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
    ) {
      this.$store.dispatch('loadAgents')
      this.$store.dispatch('loadAgentGroups')
      this.$store.dispatch('loadAgentSubGroups')
    }
    vm.$store.dispatch('livechatnotiunread').then((val) => {
      if (val && document.getElementById('noti_sound')) document.getElementById('noti_sound').play()
    })

    let refreshNotiunread = ['102052945584054', '106855151601601'].includes(vm.livechat.pageid)
      ? 30000
      : vm.$store.getters.getLivechatDetail('maxFatchReadTime')
    vm.timer = setInterval(() => {
      vm.$store.dispatch('livechatnotiunread').then((val) => {
        if (val && document.getElementById('noti_sound'))
          document.getElementById('noti_sound').play()
      })
    }, refreshNotiunread)

    if ([...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
      await this.handleBbqFetchAllStatusColor()
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  mounted: function () {
    var vm = this

    if (
      ['universalutilities', 'hafele', 'scgallrent', 'scgworkplace', 'nvbb', 'toaecoupon'].includes(
        vm.selectedBot.theme
      ) ||
      vm.isGpfBuddy ||
      this.$route.query.app == 'line'
    ) {
      this.$store.commit('SET_LIVECHAT_APP', 'line')
      this.$store.commit('SET_LIVECHAT_TYPE', 'admin')
    } else {
      this.$store.commit('SET_LIVECHAT_APP', 'facebook')
      this.$store.commit('SET_LIVECHAT_TYPE', 'admin')
    }
    if (this.$route.query.pageid) {
      this.$store.state.livechat.pageid = this.$route.query.pageid
      this.$store.state.selectedBot.pageid = this.$route.query.pageid
      // var bot = this.botlist.map(el => {

      //   return { name: el.pagename, value: el.pageid, isLock: isLock, theme: el.theme }
      // })
      // bot.find(el => el.pageid == this.$route.query.pageid)
    }
  },
  computed: {
    newchatnotify() {
      return this.$store.state.newchatnotify
    },
    isUnlock() {
      var bot = this.botlist.find((el) => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false
      return (
        (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && bot.pageid == '270028443161479') ||
        bot.isUnlockLivechat
      )
    },

    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechat: 'livechat'
    }),
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map((el) => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    },

    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    filter() {
      return this.$store.state.filter
    },
    areaname: function () {
      var area = this.$store.state.uuAreaName
      area.unshift('')
      return area
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    changePage() {
      console.log('changePage')
      // this.newchatnotify = {}
      this.selectedUser = null
    },
    deleteTag(index) {
      this.$store.state.livechat.filter.tags.splice(index, 1)
    },
    clearSearch() {},
    getUsersdata: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }

        api.getUsersdata(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    onEndSession: async function () {
      await this.endSession()
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
    },
    endSession: function () {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.endSessionChat(data, function (error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            reject(error)
          }

          console.log('endSession')
          vm.selectedUser = null

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    onOpenSession: async function () {
      await this.openSession()
      this.$store.commit('SET_LIVECHAT_TYPE', 'admin')
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
    },
    openSession: function () {
      let vm = this

      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.openSessionChat(data, function (error, response) {
          if (error) {
            vm.$store.dispatch('loading')

            reject(error)
          }

          vm.$set(vm.selectedUser, 'type', 'admin')
          vm.$set(vm.selectedUser, 'context', 'contactadmin')
          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    updateRoute: function () {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
    async handleBbqFetchAllStatusColor() {
      const vm = this
      try {
        const pageId = vm.selectedBot.pageid
        vm.$store.dispatch('loading')
        const response = await api.getStatusColor(pageId)
        vm.$store.dispatch('loading')
        if (response && response.data) {
          vm.$store.state.bbqStatusColor = response.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      if (newVal != oldVal) {
        var isCurrentUser = this.$store.state.livechat.currentUser

        if (isCurrentUser !== null && newVal.pageid !== this.$store.state.livechat.pageid) {
          this.$set(this.$store.state.livechat, 'currentUser', null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/livechat/Livechat.js